export const CREATORS = ['pira', 'dotcom', '__nyan299'] as const
export type CREATOR = (typeof CREATORS)[number]

export const mapAmoungUsCreatorInfo: Record<
  CREATOR,
  {
    profileCardImageURL: string
    creatorImageURL: string
  }
> = {
  pira: {
    profileCardImageURL: '/static/images/profiles/amongus1/0.png',
    creatorImageURL: '/static/images/creators/_pira__.png',
  },
  dotcom: {
    profileCardImageURL: '/static/images/profiles/amongus2/0.jpg',
    creatorImageURL: '/static/images/creators/dotcom.png',
  },
  __nyan299: {
    profileCardImageURL:
      'https://storage.googleapis.com/nadare-production-static-images/static/images/profileCards/amongus/amongus3/templates/0.jpg',
    creatorImageURL: '/static/images/creators/__nyan299.png',
  },
}

export const creatorMapTargetId: Record<CREATOR, string> = {
  pira: 'amongus1',
  dotcom: 'amongus2',
  __nyan299: 'amongus3',
}
